import {ReactReduxContext, useDispatch, useSelector} from "react-redux";
import React, {useContext} from "react";
import HelpText from "../helptext";
import {setFormData} from "../../actions";

/**
 * Creates an input element for step 3 of a form.
 *
 * @param {Object} options - The options for the input element.
 * @param {string} options.labelText - The text to be displayed as the input label.
 * @param {string} options.infoText - Help text (optional).
 * @param {string} options.infoName - HelpText's data-name attribute (for automated testing).
 * @param {boolean} options.noMobileChange - A flag to suppress the help text alignment adjustment when on mobile.
 * @param {string} options.record - The record or field name for the input.
 * @returns {React.Component} - The input element.
 */
export function Step3Input({labelText, infoText, infoName, noMobileChange, record}) {

    const dispatch = useDispatch();
    const context = useContext(ReactReduxContext);
    let finalClass = "step3Header";

    const error = () => context.store.getState().app.errors.step3;
    const errorMap = useSelector(error);

    if (record in errorMap) {
        finalClass += ' error';
    }

    const selectInput = () => context.store.getState().app.stepData.step3[record];

    return (
        <div className="step3Input">
            <div className="step-3-label-container">
                <label htmlFor={record} className={finalClass}>{labelText}</label>
                {
                    infoText ?
                        <HelpText
                            preventMobileAdjustment={noMobileChange}
                            name={infoName}
                            text={infoText}
                        /> : null
                }
            </div>
            <input type="text" name={record} id={record} maxLength="50" className="step3TextBox"
                   onChange={(e) => {
                       let v = {};
                       v[record] = e.target.value;
                       dispatch(setFormData(3, v));
                   }}
                   value={useSelector(selectInput) ?? ""}
            />
        </div>
    );
}